import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

export const prepareGroupItem = data => {

  return {
    ...data,
    key: data.id,
    group: {
      id: data.id,
      name: data.name,
      total_users: data.total_users,
      type: data.type,
      sync_status: data.sync_status
    },
    creators: {
      count: data.total_users,
      list: data.top_users,
      sync_status: data.sync_status
    },
    query_data: data.query_data,
    sync_status: data.sync_status,
    select: { id: data.id, value: false },
    operations: data
  };
};

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = prepareGroupItem(item);
    dataTable.push(el);
  });

  return dataTable;
};

function* getMyCreatorsGroups({ payload: { signal, searchQ, curr_page, type, filterPredefined, skipStateUpdate, onSuccess, onError } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.modifiers.regularusers.list,
      params: {
        page: curr_page,
        q: searchQ,
        ...(type ? { type } : {})
      },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(filterPredefined ? data.results.filter(x => x.type !== 'predefined') : data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    onSuccess && onSuccess(preparedData);

    if (!skipStateUpdate) {
      yield put(actions.getMyCreatorsGroupsDone(preparedData));
    }
  } catch (error) {
    onError && onError(error);

    if (skipStateUpdate) {
      return;
    }

    yield handleErrors({
      error,
      putErrorData: actions.getMyCreatorsGroupsFailed,
      endpoint: api.modifiers.regularusers.list.url
    });
  }
}

export const getMyCreatorsGroupsSaga = takeEvery(types.GET_MY_CREATORS_GROUPS_REQUEST, getMyCreatorsGroups);

function* pollMyCreatorsGroups({ payload: { searchQ, curr_page, type, filterPredefined } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.modifiers.regularusers.list,
      params: {
        page: curr_page,
        q: searchQ,
        ...(type ? { type } : {})
      }
    });

    yield put(actions.pollMyCreatorsGroupsDone({ dataTable: prepareDataTable(filterPredefined ? data.results.filter(x => x.type !== 'predefined') : data.results) }));
  } catch (error) {
    // silent — polling errors are ignored to avoid disrupting the UI
  }
}

export const pollMyCreatorsGroupsSaga = takeEvery(types.POLL_MY_CREATORS_GROUPS_REQUEST, pollMyCreatorsGroups);